import { useEffect, useRef } from 'react';

import classNames from 'classnames';

import { Avatar, Stack, Text } from '@iconik-io/uad';

import { getEntityById } from '../../../../redux/entities/utils';
import { useAppSelector } from '../../../../redux/redux_hooks';

import styles from './mentions_list_item.module.css';

type MentionsListItemProps = {
  id: string;
  label: string;
  onClick: (id: string) => void;
  active?: boolean;
};

export function MentionsListItem({
  id,
  label,
  onClick,
  active,
}: MentionsListItemProps) {
  const [type, parsedId] = id.split(':');
  const stackRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (active && stackRef.current) {
      stackRef.current.scrollIntoView({ block: 'nearest' });
    }
  }, [active]);

  const entity = useAppSelector((state) =>
    type === 'user_id'
      ? getEntityById(state, 'users_basic', parsedId)
      : undefined,
  );

  return (
    <Stack
      onClick={() => onClick?.(id)}
      key={`mention_${id}`}
      id={id}
      direction="row"
      alignItems="center"
      className={classNames(styles.list_item_wrapper, {
        [styles.active]: active,
      })}
      ref={stackRef}
    >
      <Avatar label={label} size="m" src={entity?.photo_small} />
      <Text color="high_emphasis">{label}</Text>
    </Stack>
  );
}
